import { render } from "./hotelControl.vue?vue&type=template&id=0a85e0d6&scoped=true"
import script from "./hotelControl.vue?vue&type=script&lang=js"
export * from "./hotelControl.vue?vue&type=script&lang=js"

import "./hotelControl.vue?vue&type=style&index=0&id=0a85e0d6&rel=stylesheet%2Fscss&lang=scss"
import "./hotelControl.vue?vue&type=style&index=1&id=0a85e0d6&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a85e0d6"]])

export default __exports__